import { Avatar } from '@mui/material';
import { Stack, useMediaQuery } from '@mui/system';

import Text from '@app/frontend/components/text';

type Props = {
  name: string | null;
  email: string;
  imgSrc?: string;
};

export const ProfileAvatar = ({ name, imgSrc, email }: Props) => {
  const initials = name
    ?.split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase();

  const isLargeScreen = useMediaQuery('(min-width: 900px)');

  return (
    <Stack direction='row' spacing={2} minWidth={0}>
      {initials && initials.length >= 2 && (
        <Avatar
          sx={{ background: 'linear-gradient(45deg, #66C8FF 30%, #1F29BC 98%)' }}
          alt='User avatar'
          src={imgSrc}>
          {`${initials[0]}${initials[1]}`}
        </Avatar>
      )}
      {isLargeScreen && (
        <Stack direction='column' minWidth={0} flexGrow={1}>
          <Text.Body noWrap>{name}</Text.Body>
          <Text.Body noWrap color={'#979797'}>
            {email}
          </Text.Body>
        </Stack>
      )}
    </Stack>
  );
};
